export { default } from './ForgotCredentialsModal';
export { default as reducer } from './ForgotCredentials.ducks';
export { default as sagas } from './ForgotCredentials.sagas';

import * as actions from './ForgotCredentials.ducks';
export { actions };
